import * as Yup from "yup";

export const createRechargeValidationSchema = Yup.object().shape({
  money: Yup.number()
    .typeError("Bạn cần nhập số")
    .min(50000, "Bạn cần nạp tối thiểu 50.000đ")
    .max(100000000, "Bạn được nạp tối đa 100.000.000đ")
    .required("Số tiền không được để trống"),
  bankId: Yup.string().required("Thông tin ngân hàng nhận không được để trống"),
});
